import { InsuranceCoverageMonitor } from "../../../../../../services/api/insurance/monitor/types";

export const getInsuranceCoverageRequirementName = (
  insuranceCoverage: InsuranceCoverageMonitor | undefined,
  defaultName: string
): string => {
  if (!insuranceCoverage) {
    return defaultName || "Insurance Coverage";
  }

  return defaultName;
};
